<template lang="pug">
div.logo-container(:class="{'warning-message-margin': showWarningMessage }")
  router-link.logo-any(to='/')
    img.logo(src="/img/logo.svg?v2", alt="unMineable logo")
</template>
<script>
export default {
  name: 'c_logo_stats',
  computed: {
    showWarningMessage() {
      return this.$store.getters.showWarningMessage
    }
  }
}
</script>

<style lang="stylus" scoped>
.logo-container
  text-align left 
  max-width: 1080px;
  margin auto
  margin-bottom 10px
  margin-top 5px
.logo-any
  display inline-block
  max-width 200px
  padding-left: 5px
  .logo
    width: 157px;
    height: 45px;
    vertical-align: bottom;

@media (max-width: 439px)
  .logo-container
    margin-top -10px
  .warning-message-margin
    margin-top 25px
</style>



// WEBPACK FOOTER //
// c_logo_stats.vue?7854f566